// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"222":"9d854bda","798":"c1938ef5"}[chunkId] + ".chunk.js");